"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertProcedureToNodeMap = void 0;
var nodemap_generics_1 = require("../nodemap/nodemap-generics");
function convertProcedureToNodeMap(steps) {
    return nodemap_generics_1.convertListOfStepsToNodeMap(steps);
}
exports.convertProcedureToNodeMap = convertProcedureToNodeMap;
